import {mapActions} from 'vuex';
import {getCurrentUserStatus} from '@/js/common/util';

export default {
  methods: {
    ...mapActions({
      getUserInfo: 'user/getUserInfo',
      getExamInfo: 'user/getExamInfo',
      getExamPeriod: 'user/getExamPeriod',
    }),
    async fetchData(userId) {
      let user = null;
      let period = null;
      let exam = null;
      const datas = {
        user,
        period,
        exam,
      };

      try {
        user = await this.getUserInfo(userId);
        period = await this.getExamPeriod(user.examPeriodId);
        exam = await this.getExamInfo(user.examId);
        return {
          user,
          exam,
          period,
        };
      } catch (error) {
        this.errorModal(error);
        return datas;
      }
    },

    getStatus(exam, period, user) {
      const examStatus = getCurrentUserStatus(exam, period, user);
      return examStatus;
    },
  },
};
